import React from 'react'
import { theme } from '../../styles/theme'

interface CardProps {
  children: React.ReactNode
  onClick?: () => void
  hoverable?: boolean
  padding?: string
  style?: React.CSSProperties
  className?: string
  onMouseEnter?: (e: React.MouseEvent<HTMLDivElement>) => void
  onMouseLeave?: (e: React.MouseEvent<HTMLDivElement>) => void
}

export const Card: React.FC<CardProps> = ({
  children,
  onClick,
  hoverable = false,
  padding = '24px',
  style,
  className,
  onMouseEnter: onMouseEnterProp,
  onMouseLeave: onMouseLeaveProp,
}) => {
  const [isHover, setIsHover] = React.useState(false)

  const baseStyles: React.CSSProperties = {
    backgroundColor: '#FFFFFF',
    border: `1px solid ${theme.colors.border}`,
    borderRadius: '12px',
    padding,
    boxShadow: theme.shadows.sm,
    transition: 'all 0.2s ease',
    cursor: onClick ? 'pointer' : 'default',
    ...style,
  }

  const hoverStyles: React.CSSProperties = hoverable || onClick ? {
    transform: 'translateY(-2px)',
    boxShadow: theme.shadows.md,
  } : {}

  return (
    <div
      className={className}
      onClick={onClick}
      onMouseEnter={(e) => {
        setIsHover(true)
        onMouseEnterProp?.(e)
      }}
      onMouseLeave={(e) => {
        setIsHover(false)
        onMouseLeaveProp?.(e)
      }}
      style={{
        ...baseStyles,
        ...(isHover ? hoverStyles : {}),
      }}
    >
      {children}
    </div>
  )
}
